var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createRef } from 'react';
import { ITEM_PREFIXES } from '../../constants';
import { getItemAutoId } from '../../helpers';
export function isBaseItem(item) {
    return item && !('items' in item);
}
export function isAccordionItem(item) {
    return item && 'items' in item && item['type'] === 'collapse';
}
export function isNextListItem(item) {
    return item && 'items' in item && item['type'] === 'next-list';
}
export function isGroupItem(item) {
    return item && 'items' in item && item['type'] === 'group';
}
export function isGroupSelectItem(item) {
    return item && 'items' in item && item['type'] === 'group-select';
}
export function isContentItem(item) {
    return typeof item === 'object' && item['option'] !== undefined;
}
export const isBaseItemProps = isBaseItem;
export const isAccordionItemProps = isAccordionItem;
export const isNextListItemProps = isNextListItem;
export const isGroupItemProps = isGroupItem;
export function kindFlattenItems({ items, prefix, parentId }) {
    const flattenItems = {};
    const focusFlattenItems = {};
    function flatten({ item, idx, prefix, parentId = ITEM_PREFIXES.default }) {
        var _a, _b;
        const autoId = prefix !== undefined ? getItemAutoId(prefix, idx) : String(idx);
        const itemId = (_a = (!isGroupItem(item) ? item.id : undefined)) !== null && _a !== void 0 ? _a : autoId;
        if (isBaseItem(item)) {
            flattenItems[itemId] = Object.assign(Object.assign({}, item), { items: [], allChildIds: [], id: itemId });
            focusFlattenItems[autoId] = {
                key: autoId,
                originalId: itemId,
                id: autoId,
                disabled: item.disabled,
                parentId,
                items: [],
                allChildIds: [],
                itemRef: item.itemRef || createRef(),
            };
            return { id: itemId, children: [itemId], autoId, focusChildren: [autoId] };
        }
        let allChildIds = [];
        let allFocusChildIds = [];
        const closeChildIds = [];
        const autoChildIds = [];
        const { items } = item, rest = __rest(item, ["items"]);
        const childActiveParent = isGroupItem(item) ? (parentId !== null && parentId !== void 0 ? parentId : ITEM_PREFIXES.default) : autoId;
        const filteredItems = items.filter(item => !item.hidden);
        for (let idx = 0; idx < filteredItems.length; idx++) {
            const { id, children, autoId, focusChildren } = flatten({
                item: filteredItems[idx],
                idx,
                prefix: itemId,
                parentId: childActiveParent,
            });
            autoChildIds.push(autoId);
            closeChildIds.push(id);
            allChildIds = allChildIds.concat(children);
            allFocusChildIds = allFocusChildIds.concat(focusChildren);
        }
        const children = [...new Set(allChildIds.concat(closeChildIds))];
        const focusChildren = [...new Set(allFocusChildIds.concat(autoChildIds))];
        flattenItems[itemId] = Object.assign(Object.assign({}, rest), { id: itemId, items: [], allChildIds: children });
        focusFlattenItems[autoId] = {
            key: autoId,
            originalId: itemId,
            id: autoId,
            parentId,
            items: autoChildIds,
            allChildIds: focusChildren,
            disabled: (item.type === 'collapse' || item.type === 'next-list') && item.disabled,
            type: item.type,
            itemRef: !isGroupItem(item) ? ((_b = item.itemRef) !== null && _b !== void 0 ? _b : createRef()) : undefined,
        };
        return { id: itemId, children, autoId, focusChildren };
    }
    const closeChildIds = [];
    const autoChildIds = [];
    let allChildIds = [];
    const filteredItems = items.filter(item => !item.hidden);
    for (let idx = 0; idx < filteredItems.length; idx++) {
        const { id, children, autoId } = flatten({ item: filteredItems[idx], idx, prefix, parentId });
        autoChildIds.push(autoId);
        closeChildIds.push(id);
        allChildIds.push(id);
        allChildIds = allChildIds.concat(children);
    }
    const children = [...new Set(allChildIds)];
    return {
        focusCloseChildIds: autoChildIds,
        allChildIds: children,
        flattenItems,
        focusFlattenItems,
    };
}
export function extractActiveItems({ focusFlattenItems, focusCloseChildIds, openCollapseItems, isSelectionMultiple, }) {
    const ids = [];
    const expandedIds = [];
    function internalFn(focusCloseChildIds) {
        focusCloseChildIds.forEach(id => {
            const child = focusFlattenItems[id];
            if (child.type === 'group') {
                internalFn(child.items);
                return;
            }
            if (!child.disabled) {
                if (child.type === 'group-select') {
                    if (isSelectionMultiple) {
                        ids.push(child.id);
                    }
                    internalFn(child.items);
                    return;
                }
                ids.push(child.id);
                if (child.type) {
                    expandedIds.push(id);
                    if (openCollapseItems.includes(child.originalId)) {
                        internalFn(child.items);
                    }
                }
            }
        });
    }
    internalFn(focusCloseChildIds);
    return {
        ids,
        expandedIds,
    };
}
